import type {
  SupplierOrderItem,
  SupplierProductRow,
  SupplierUnitQuantity,
} from "@/features/supplierPedidos/types";
import { formatQuantityDisplay, getQuantityUnitLabel } from "@/lib/quantity";

export function getSupplierProductDisplayQuantity(
  row: Pick<SupplierProductRow, "ordered_quantity" | "quantity">,
) {
  return row.ordered_quantity ?? row.quantity;
}

const unitOrder = ["kg", "cx", "bdj", "sc", "un"] as const;

export function formatSupplierUnitSummary(
  quantities: SupplierUnitQuantity[] | undefined,
) {
  return (quantities ?? [])
    .filter((item) => (item.ordered_quantity ?? item.quantity) > 0)
    .sort(
      (a, b) => unitOrder.indexOf(a.unit_type) - unitOrder.indexOf(b.unit_type),
    )
    .map((item) => {
      const quantity = item.ordered_quantity ?? item.quantity;
      return `${formatQuantityDisplay(quantity, item.unit_type)} ${getQuantityUnitLabel(item.unit_type)}`;
    })
    .join(" · ");
}

export function getSupplierOrderItemDisplayQuantity(
  item: Pick<SupplierOrderItem, "ordered_quantity" | "quantity">,
) {
  return item.ordered_quantity ?? item.quantity;
}
